<div #popup class=" no-select mat-dialog-edition-form mat-dialog" appDraggable>
    <div class="popup-header d-flex justify-content-between align-items-center">
      <h2 class="title mx-auto text-center w-100 fs-6">
  
        {{ isNew ? ('SETTINGS.NEW_AREA' | translate) : ('SETTINGS.MODIFY_AREA'
        |
        translate) }}
  
      </h2>
      <button type="button" class="btn-close ms-auto p-2" data-bs-dismiss="modal" aria-label="Close"
        (click)="onClose()"></button>
    </div>

      <!-- CONTENT -->
  <div class="popup-content">
    <form class="form" [formGroup]="form!" (ngSubmit)="onSubmit()" id="ngForm">

      <!-- ROW 1 -->
      <div class="d-flex">
        <div class="row-item-width-100 input-container">
          <label class="input-label">{{ 'SETTINGS.NAME' | translate }}</label>
          <input class="input-field" id="name" placeholder="{{ 'SETTINGS.NAME' | translate }}" formControlName="name" name="name" type="text" />
          @if(form?.get('name')?.invalid && form?.get('name')?.touched){
          <div class="input-errors">
            @if(form?.get('name')?.errors?.['required']){
            <span>{{ 'SETTINGS.NAME_REQUIRED' | translate }}</span>
            }
          </div>
          }
        </div>

        <div class="col-6 input-container">
            <div class="row-item-width-100 input-container">
              <label class="input-label" for="organization">{{ 'SETTINGS.ORGANISATION' | translate }}</label>
              
              <ng-select
                name="organization"
                id="organization"
                [items]="organizations"
                bindLabel="name"
                bindValue="orgId"
                formControlName="organization"
                [multiple]="false"
                [closeOnSelect]="true"
                [hideSelected]="true"
                [searchable]="true"
                notFoundText="{{ 'PLACEHOLDERS.NO_ITEM_FOUND' | translate }}"
                placeholder="{{ 'SETTINGS.ORGANISATION' | translate }}"
              >
              </ng-select>
          
              @if (form?.get('organization')?.invalid && form?.get('organization')?.touched) {
                <div class="input-errors">
                  @if (form?.get('organization')?.errors?.['required']) {
                    <span>{{ 'SETTINGS.ORGANIZATION_REQUIRED' | translate }}</span>
                  }
                </div>
              }
            </div>
          </div>
          
      </div>
    </form>
    </div>
    <div class="popup-footer">
        <button class="secondary-button popup-secondary-button" (click)="onClose()">{{ 'BUTTONS.CANCEL' | translate }}</button>
        <button class="primary-button popup-primary-button" form="ngForm" type="submit">{{ 'BUTTONS.CONFIRM' | translate }}</button>
      </div>
</div>